import React from "react"

import { Link } from "gatsby"
import PropTypes from "prop-types"

import * as styles from "./submenu.module.scss"

const Submenu = ({ menu, hamburger }) => (
  <ul
    className={`${styles.submenu} ${
      !hamburger ? styles.submenu__popover : ""
    } ${menu.length > 10 ? styles.submenu__long : ""}`}
  >
    {menu.map((subitem) => (
      <li className={styles.item} key={subitem.url}>
        <Link
          activeClassName={styles.link__active}
          className={styles.link}
          to={subitem.url}
        >
          {subitem.title}
        </Link>
      </li>
    ))}
  </ul>
)

export default Submenu

Submenu.propTypes = {
  menu: PropTypes.array.isRequired,
  hamburger: PropTypes.bool,
}

Submenu.defaultProps = {
  hamburger: false,
}
